import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {lastValueFrom, Observable} from 'rxjs';
import {userInfoStore} from '../elf-store/user-info/user-info.store';
import {AuthService} from '../../auth/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AgencyPortalAuthGuard {
  private router = inject(Router);
  private authService = inject(AuthService);
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isEnabled = await this.isCanBeActivated();
    if (!isEnabled) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }

  async isCanBeActivated() {
    if (
      !userInfoStore.getValue().userInfo?.agencyAccount ||
      userInfoStore.getValue().userInfo?.isPartner === undefined
    ) {
      await lastValueFrom(this.authService.loadUserOrTeamDataBasedOnSwitch());
    }
    return userInfoStore.getValue().userInfo?.agencyAccount?.enabled || userInfoStore.getValue().userInfo?.isPartner;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }
}
